import React, { useCallback, useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const PRODUCT = {
  name: 'Pack Completo',
  price: '$11.99',
  image: 'https://cdn.magicpatterns.com/uploads/gSF2vXRe6qeZsfde2hd5jZ/mk-01.png'
};
const NAMES = ['Carlos', 'María', 'Andrés', 'Valentina', 'Diego', 'Camila', 'Sebastián', 'Lucía', 'Mateo', 'Isabella', 'Santiago', 'Sofía', 'Alejandro', 'Daniela', 'Gabriel', 'Mariana', 'Nicolás', 'Paula', 'Fernando', 'Andrea', 'Javier', 'Carolina', 'Ricardo', 'Natalia', 'Emilio', 'Gabriela', 'Tomás', 'Valeria', 'Martín', 'Lorena'];
const CITIES = ['Ciudad de México', 'Bogotá', 'Buenos Aires', 'Lima', 'Santiago', 'Medellín', 'Guadalajara', 'Quito', 'Montevideo', 'San José', 'Caracas', 'Panamá', 'Santo Domingo', 'La Paz', 'Asunción', 'Monterrey', 'Cali', 'Córdoba', 'Guayaquil', 'Tegucigalpa'];
const FIRST_DELAY = 3000;
const TOAST_DURATION = 4000;
const MIN_INTERVAL = 8000;
const MAX_INTERVAL = 15000;
const NAME_HISTORY_SIZE = 10;
function getRandomItem<T>(list: T[], exclude?: T[]): T {
  if (exclude && exclude.length > 0) {
    const filtered = list.filter(item => !exclude.includes(item));
    if (filtered.length > 0) {
      return filtered[Math.floor(Math.random() * filtered.length)];
    }
  }
  return list[Math.floor(Math.random() * list.length)];
}
function getRandomInterval(): number {
  return MIN_INTERVAL + Math.random() * (MAX_INTERVAL - MIN_INTERVAL);
}
interface ToastData {
  id: number;
  name: string;
  city: string;
}
export function RecentPurchaseToast() {
  const [toast, setToast] = useState<ToastData | null>(null);
  const nameHistoryRef = useRef<string[]>([]);
  const counterRef = useRef(0);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();
  const dismissRef = useRef<ReturnType<typeof setTimeout>>();
  const prefersReducedMotion = typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const showToast = useCallback(() => {
    const name = getRandomItem(NAMES, nameHistoryRef.current);
    const city = getRandomItem(CITIES);
    nameHistoryRef.current.push(name);
    if (nameHistoryRef.current.length > NAME_HISTORY_SIZE) {
      nameHistoryRef.current.shift();
    }
    counterRef.current += 1;
    setToast({
      id: counterRef.current,
      name,
      city
    });
    dismissRef.current = setTimeout(() => {
      setToast(null);
    }, TOAST_DURATION);
  }, []);
  const scheduleNext = useCallback(() => {
    timerRef.current = setTimeout(() => {
      showToast();
      scheduleNext();
    }, getRandomInterval());
  }, [showToast]);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showToast();
      scheduleNext();
    }, FIRST_DELAY);
    return () => {
      clearTimeout(initialTimer);
      clearTimeout(timerRef.current);
      clearTimeout(dismissRef.current);
    };
  }, [showToast, scheduleNext]);
  const variants = prefersReducedMotion ? {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  } : {
    initial: {
      opacity: 0,
      y: 40
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: 40
    }
  };
  return <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 pointer-events-none" data-id="element-79">
      <AnimatePresence mode="wait" data-id="element-80">
        {toast && <motion.div key={toast.id} variants={variants} initial="initial" animate="animate" exit="exit" transition={{
        duration: prefersReducedMotion ? 0.1 : 0.4,
        ease: 'easeOut'
      }} className="pointer-events-auto flex items-center gap-3 bg-[#111111] border border-[#1a1a1a] rounded-lg px-4 py-3 shadow-lg shadow-black/40 max-w-sm w-max" data-id="element-81">
            <img src={PRODUCT.image} alt={PRODUCT.name} className="w-10 h-10 object-contain rounded flex-shrink-0" data-id="element-82" />
            <p className="text-sm text-gray-200 leading-snug" data-id="element-83">
              <span className="font-semibold text-white" data-id="element-84">{toast.name}</span> en{' '}
              <span className="text-gray-300" data-id="element-85">{toast.city}</span> acaba de
              comprar{' '}
              <span className="font-semibold text-[#d4a853]" data-id="element-86">
                {PRODUCT.name}
              </span>
              {' — '}
              <span className="font-bold text-[#d4a853]" data-id="element-87">{PRODUCT.price}</span>
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}